import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 15l-3 -3l3 -3","key":"svg-0"}],["path",{"d":"M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9","key":"svg-1"}]]

const IconSquareRoundedChevronLeft = createReactComponent('outline', 'square-rounded-chevron-left', 'SquareRoundedChevronLeft', __iconNode);

export default IconSquareRoundedChevronLeft;